// Modules
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { CallbackComponent } from './shared/components';

const routes: Routes = [
  { path: 'callback', component: CallbackComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  declarations: [
    CallbackComponent
  ]
})

export class AuthorizationModule { }
